import React from "react";
import Socials from "./Socials";
import "../scss/import.scss";
import 'animate.css';

const Home = (props) => {
    return (
    <div className="home animate__animated animate__fadeInRight" >
      <span className="background_text">{props.homePageH1}</span>
      <div className="home_context ">
        <h1 className="title">{props.homePageH1}</h1>
        <p className="home_context_sub"><i>&lsaquo;h5&rsaquo;</i> <span> Frontend Developer </span>
          <i>&lsaquo;/h5&rsaquo;</i></p>
      <Socials/>

      </div >
    </div>
  );
};

export default Home;
